import dynamic from 'next/dynamic';
const FractionDisplay = dynamic(() => import('./FractionDisplay'));
export default FractionDisplay;
